export default {
  // Binding type options
  drone: 'Drone',
  dog: 'Robot Dog',

  // Drone binding
  droneBinding: {
    // Basic
    loading: 'Loading...',
    project: 'Project',
    selectProject: 'Please select project',

    // Table columns
    routeName: 'Route Name',
    payload: 'Payload',
    updateTime: 'Update Time',
    operation: 'Operation',

    // Action buttons
    bindAlgorithm: 'Bind Algorithm',
    clearBinding: 'Clear Binding',

    // Modal
    algorithmModalTitle: 'Algorithm Model & Point Binding',
    addModel: 'Add Model',
    noBindingData: 'No binding data, please add models first.',

    // Table columns (inside modal)
    modelName: 'Model Name',
    selectModel: 'Please select model',
    skipFrame: 'Skip Frame',
    confidence: 'Confidence',
    resolution: 'Resolution',
    startPoint: 'Start Point',
    endPoint: 'End Point',
    actions: 'Actions',
    selectActions: 'Please select actions',

    // Button operations
    cancel: 'Cancel',
    confirm: 'Confirm',

    // Messages
    routeInfoMissing: 'Route information missing',
    clearedBinding: 'Binding cleared',
    selectValidModel: 'Please select a valid model for each row',
    bindSuccess: 'Algorithm bound successfully',
    selectProjectFirst: 'Please select a project first',
    routeIdInvalid: 'Route ID invalid',

    // Confirmation dialogs
    clearBindingTitle: 'Confirm clear binding?',
    clearBindingContent: 'Will clear all algorithm bindings for "{name}", this action cannot be undone.',
    confirmClear: 'Confirm Clear',

    // Action options
    voice: 'Voice Call',
    photo: 'Photo',
    flash: 'Flash Light',
    ir: 'Spotlight',
  },

  // Dog binding
  dogBinding: {
    // Basic
    loading: 'Loading...',
    mapName: 'Map Name',
    mapNamePlaceholder: 'Please enter map name',
    query: 'Search',

    // Table columns
    routeName: 'Route Name',
    deviceSn: 'Device SN',
    createTime: 'Creation Time',
    operation: 'Operation',

    // Action buttons
    bindAlgorithm: 'Bind Algorithm',
    clearBinding: 'Clear Binding',

    // Modal
    algorithmModalTitle: 'Algorithm Model & Point Binding',
    addModel: 'Add Model',
    noBindingData: 'No binding data, please add models first.',

    // Table columns (inside modal)
    modelName: 'Model Name',
    selectModel: 'Please select model',
    skipFrame: 'Skip Frame',
    confidence: 'Confidence',
    resolution: 'Resolution',
    startPoint: 'Start Point',
    endPoint: 'End Point',
    actions: 'Actions',
    selectActions: 'Please select actions',

    // Button operations
    cancel: 'Cancel',
    confirm: 'Confirm',

    // Messages
    mapInfoMissing: 'Map information missing',
    clearedBinding: 'Binding cleared',
    selectValidModel: 'Please select a valid model for each row',
    bindSuccess: 'Algorithm bound successfully',
    mapIdInvalid: 'Map ID invalid',
    loadPointsFailed: 'Failed to load map points',
    noMapPoints: 'Current map has no points, please maintain points in map management first',
    loadBindingFailed: 'Failed to load binding data',

    // Confirmation dialogs
    clearBindingTitle: 'Confirm clear binding?',
    clearBindingContent: 'Will clear all algorithm bindings for "{name}", this action cannot be undone.',
    confirmClear: 'Confirm Clear',

    // Action options
    voice: 'Voice Call',
    pause: 'Pause',
    speedDown: 'Speed Down',
    takePhoto: 'Take Photo',
  },
}
